var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletRafiki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-24"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.04,
    y: 388.78,
    width: 23.18,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.1,
    y: 394.14,
    width: 56.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.72,
    y: 394.14,
    width: 56.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71h0V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.48,5.48,0,0,0,5.46-5.46V60.66A5.48,5.48,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.73,5.73,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.7,5.7,0,0,1,453.31,337.8ZM260.21,55.2a5.48,5.48,0,0,0-5.46,5.46V332.09a5.48,5.48,0,0,0,5.46,5.46h193.1a5.48,5.48,0,0,0,5.46-5.46V60.66a5.48,5.48,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.98,
    y: 303.03,
    width: 23.09,
    height: 79.91,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.63,
    y: 303.03,
    width: 23.09,
    height: 79.91,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.34 382.94 298.72 382.94 298.72 370.46 289.73 370.46 294.34 382.94",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.56,
    y: 303.03,
    width: 23.09,
    height: 79.91,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.83,
    y: 303.03,
    width: 119.9,
    height: 73.77,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.26,360.2h-47a4.59,4.59,0,0,1-4.57-4.57V310.72a4.57,4.57,0,0,1,4.57-4.56h46.95a4.57,4.57,0,0,1,4.57,4.56v44.91A4.59,4.59,0,0,1,291.26,360.2Zm-47-53a3.56,3.56,0,0,0-3.56,3.54v44.91a3.56,3.56,0,0,0,3.52,3.6h47a3.56,3.56,0,0,0,3.58-3.53v-45a3.54,3.54,0,0,0-3.55-3.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.24,360.2h-47a4.59,4.59,0,0,1-4.57-4.57V310.72a4.57,4.57,0,0,1,4.57-4.56h47a4.57,4.57,0,0,1,4.57,4.56h0v44.91a4.58,4.58,0,0,1-4.57,4.57Zm-47-53a3.54,3.54,0,0,0-3.55,3.54v44.91a3.55,3.55,0,0,0,3.55,3.55h47a3.57,3.57,0,0,0,3.56-3.55V310.72a3.56,3.56,0,0,0-3.56-3.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.88,320.35a4.41,4.41,0,1,1,4.41-4.42v0A4.42,4.42,0,0,1,228.88,320.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.66,320.35a4.41,4.41,0,1,1,4.38-4.44V316A4.4,4.4,0,0,1,248.66,320.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.21 382.94 178.82 382.94 178.82 370.46 187.81 370.46 183.21 382.94",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.21,
    y: 303.03,
    width: 23.09,
    height: 79.91,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.91 382.94 175.3 382.94 175.3 370.46 166.31 370.46 170.91 382.94",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.4,
    y: 303.03,
    width: 119.9,
    height: 73.77,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.83,360.2h-47a4.57,4.57,0,0,1-4.57-4.57V310.72a4.57,4.57,0,0,1,4.57-4.56h46.95a4.57,4.57,0,0,1,4.57,4.56v44.91A4.57,4.57,0,0,1,167.83,360.2Zm-47-53a3.54,3.54,0,0,0-3.55,3.54v44.91a3.56,3.56,0,0,0,3.52,3.6h47a3.57,3.57,0,0,0,3.59-3.53v-45a3.56,3.56,0,0,0-3.55-3.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.81,360.2H62.87a4.57,4.57,0,0,1-4.57-4.57h0V310.72a4.56,4.56,0,0,1,4.57-4.56h46.94a4.56,4.56,0,0,1,4.57,4.56v44.91A4.58,4.58,0,0,1,109.81,360.2Zm-46.94-53a3.54,3.54,0,0,0-3.56,3.54v44.91a3.56,3.56,0,0,0,3.52,3.6h47a3.55,3.55,0,0,0,3.56-3.55v-45a3.54,3.54,0,0,0-3.56-3.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.46,320.35a4.41,4.41,0,1,1,4.4-4.42v0A4.4,4.4,0,0,1,105.46,320.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.24,320.35a4.41,4.41,0,1,1,4.38-4.44V316A4.4,4.4,0,0,1,125.24,320.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.78 382.94 55.4 382.94 55.4 370.46 64.38 370.46 59.78 382.94",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.32,
    y: 81.52,
    width: 42.96,
    height: 42.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.29,
    y: 81.53,
    width: 1.9,
    height: 42.96,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.15,
    y: 87.35,
    width: 31.32,
    height: 31.32,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.05,108.24h0a7.41,7.41,0,0,1-10.49,0h0a7.42,7.42,0,0,1,0-10.48h0a7.43,7.43,0,0,1,10.49,0h0A7.42,7.42,0,0,1,251.05,108.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.83,
    y: 136.76,
    width: 50.37,
    height: 50.37,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.2,
    y: 136.77,
    width: 2.23,
    height: 50.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.66,
    y: 143.59,
    width: 36.72,
    height: 36.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.18,
    y: 154.11,
    width: 15.66,
    height: 15.66,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.23,
    y: 120.56,
    width: 27.27,
    height: 6.37,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.35,
    y: 120.56,
    width: 112.88,
    height: 6.37,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.71,
    y: 86.74,
    width: 31.78,
    height: 33.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.57,
    y: 86.74,
    width: 8.14,
    height: 33.83,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.95,
    y: 81.52,
    width: 23.87,
    height: 39.04,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.06,
    y: 81.52,
    width: 6.9,
    height: 39.04,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.99,
    y: 86.74,
    width: 20.13,
    height: 33.83,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.39,
    y: 86.74,
    width: 4.6,
    height: 33.83,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.46,
    y: 92.46,
    width: 26.4,
    height: 28.1,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.7,
    y: 92.46,
    width: 6.76,
    height: 28.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.95,
    y: 88.13,
    width: 19.83,
    height: 32.44,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.22,
    y: 88.13,
    width: 5.73,
    height: 32.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.79,
    y: 92.46,
    width: 19.26,
    height: 28.1,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.97,
    y: 92.46,
    width: 3.82,
    height: 28.1,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,309.42c8.54-11.16,28.87-15.31,35.9-22.35,9.2-9.23,9.16-23.08,1.32-28.08-6.8-4.34-29.36,25-31.89,28.3-8.75,11.29-11.28,19.66-12.92,27.77.19-6.89.37-13.23.52-18.11.47-15.93,1.06-21.06,1.34-22.63,1-.78,2.06-1.67,2.7-2.15,5.46-4.07,17.56-8.92,23.61-14.83,8.84-8.64,7.41-19,1.21-22.83-6.47-4-17.93,5.49-24,14.92s-3.48,18.47-5.18,26.24c-.36,1.54-.73,7.37-1.07,15.46a32,32,0,0,0-12.34-19.95c-8.37-6.68-15.6-14.82-22.5-13.77s-3.15,11.82,2.27,19.38c4.86,6.73,28.85,13.45,32.38,18.86-.42,11-.79,24.85-1.05,37.79-1.89-6.68-.59-7.24-8.34-17.5-4.6-6.08-23.5-13.6-25.74-9.4s1.17,12.08,8.3,17.61c5.75,4.46,18.46,4.45,21.47,7.22.69.64,3,3.12,4.26,4.55-.31,15.78-.44,29.71-.29,34.47l1.24.05c-.06-1.23.08-9.26.33-19.89,3.1-5.65,24-9,30.41-14.84,6.74-6.15,11.58-13.33,8.69-18.14-2.41-4-21.38,1.44-29.15,8.08-5.14,4.42-8.28,9.15-9.72,15.49.17-7.24.38-15,.57-22.35C401,317,404.53,312.77,407.09,309.42Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.91,382.73H387.25c-1.19,0-2.21-1.54-2.44-3.68l-1.54-14h29.61l-1.53,14C411.1,381.19,410.09,382.73,408.91,382.73Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.5,370.46H382.65c-.74,0-1.36-1-1.44-2.38l-.63-10.36c-.1-1.59.57-3,1.44-3h32.12c.86,0,1.53,1.39,1.43,3l-.63,10.36C414.87,369.44,414.24,370.46,413.5,370.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-62--inject-24"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-62--inject-24",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.49,155.68c-2.21,5.37-15.22,5-28.85-.62s-22.9-14.53-20.69-19.9c.52-1.24,2-5.89,3.48-6.53,5.08-2.15,14.75,2.68,25.22,7,9.75,4,20.9,6.61,22.63,11.9C217.32,150.75,215.12,154.15,214.49,155.68Z",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.28,147.53c.83,4.21-1,6.23-1.79,8.15s-3.1,3.18-6.33,3.62a11.35,11.35,0,0,1-1.22.14,33.4,33.4,0,0,1-7.41-.39c-.35,0-.7-.11-1.06-.17A58.91,58.91,0,0,1,190,156.7l-1-.34c-1.11-.39-2.25-.82-3.39-1.29s-2.22-1-3.29-1.47l-.92-.44a59.56,59.56,0,0,1-7.27-4.26l-.82-.58a32.65,32.65,0,0,1-5.53-4.94c-.25-.28-.48-.55-.7-.83-2.15-2.72-3-5.32-2.15-7.39.56-1.33,1.76-5.88,3.48-6.54a11.93,11.93,0,0,1,6.47,0l1,.24c5,1.28,11.3,4.13,17.73,6.78,7.58,3.13,16.55,6.38,20.95,10.13a10,10,0,0,1,.75.7A9,9,0,0,1,216.28,147.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.38,128l-.46.84-8.12,14.53c-.25-.28-.48-.55-.7-.83l7.8-13.94.61-1.08Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.52,133.93l-8.37,15-.82-.58,8.32-14.88Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.91,142.53,190,156.7l-1-.34L197,142Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.75,138.53l-8.41,15.07-.92-.44L189.88,138Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.24,145.27l-7.71,13.78c-.35,0-.7-.11-1.06-.17l7.89-14.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M216.22,151c-2.21,5.37-15.06,5.16-28.7-.47s-22.9-14.53-20.68-19.9,15.06-5.15,28.7.47S218.43,145.6,216.22,151Z",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.58,149.05c-1.56,3.79-11.58,3.26-22.37-1.19s-18.27-11.14-16.71-14.93,11.58-3.26,22.38,1.19S213.15,145.26,211.58,149.05Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.41,107.14c3.56,4.59-3.22,15.7-14.89,24.73s-24,12.63-27.55,8c-.82-1.06-4.14-4.61-3.94-6.27.67-5.47,9.66-11.45,18.62-18.39,8.34-6.46,16.13-14.84,21.58-13.71C280.54,102.23,282.4,105.84,283.41,107.14Z",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.23,101.54c4.07,1.38,4.91,4,6.18,5.6s1.22,4.27,0,7.3c-.14.37-.31.74-.49,1.12a33.12,33.12,0,0,1-4,6.24c-.21.28-.44.55-.67.83a58.73,58.73,0,0,1-6.12,6.28l-.77.67c-.89.77-1.83,1.54-2.8,2.29s-1.94,1.46-2.92,2.13c-.27.2-.56.39-.83.58a58.57,58.57,0,0,1-7.32,4.18c-.31.16-.61.29-.9.43a33,33,0,0,1-7.05,2.34c-.36.08-.71.14-1.06.19-3.43.51-6.11,0-7.48-1.81-.88-1.14-4.23-4.45-3.94-6.26a11.79,11.79,0,0,1,3.21-5.63c.22-.25.46-.5.71-.76,3.61-3.74,9.2-7.75,14.7-12,6.49-5,13.77-11.19,19.2-13.13a10.2,10.2,0,0,1,1-.31A9.43,9.43,0,0,1,277.23,101.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M240.45,126.44l.5.82,8.56,14.27c-.36.08-.71.14-1.06.19L240.24,128,239.6,127Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248.64,124.06l8.82,14.7c-.31.16-.61.29-.9.43l-8.78-14.62Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.75,115l8.35,13.92-.77.67-8.44-14.08Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256.73,119.21,265.61,134c-.27.2-.56.39-.83.58l-8.92-14.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M270.77,108.25l8.12,13.55c-.21.28-.44.55-.67.83l-8.31-13.86Z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.06,
    cy: 119.65,
    rx: 26.71,
    ry: 10.51,
    transform: "translate(-19.02 183.68) rotate(-37.76)",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.5,
    cy: 119.31,
    rx: 21.14,
    ry: 7.43,
    transform: "translate(-18.72 183.87) rotate(-37.76)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.14,85.64C234,92.22,219.24,95,202.52,92s-29.33-10.73-28.16-17.31c.27-1.53.74-7.1,2.31-8.21,5.19-3.66,17.25-.6,30.09,1.68,12,2.13,25.13,2.3,28.38,7.83C237.11,79.39,235.47,83.76,235.14,85.64Z",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.14,76c2,4.54.41,7.25,0,9.61s-2.7,4.33-6.22,5.63c-.43.17-.88.31-1.34.45a38.69,38.69,0,0,1-8.44,1.39c-.41,0-.81,0-1.23.07a68.73,68.73,0,0,1-10.08-.37l-1.17-.15c-1.35-.17-2.74-.37-4.13-.62s-2.74-.53-4.07-.84c-.38-.08-.76-.18-1.14-.27a66.94,66.94,0,0,1-9.22-3c-.37-.14-.72-.3-1.07-.44a38.07,38.07,0,0,1-7.44-4.21c-.35-.25-.67-.5-1-.76-3.1-2.53-4.69-5.25-4.24-7.78.3-1.64.54-7,2.3-8.21s4.28-1.59,7.28-1.6h1.2c6,.2,13.73,1.87,21.62,3.27,9.3,1.66,20.19,3.11,26.05,6.25a11,11,0,0,1,1,.6A10.64,10.64,0,0,1,235.14,76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M185.46,63.88l-.32,1.05-5.56,18.34c-.35-.25-.67-.5-1-.76l5.34-17.59.42-1.37Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M193.82,69l-5.73,18.89c-.37-.14-.72-.3-1.07-.44l5.7-18.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.25,74.92l-5.43,17.89-1.17-.15,5.49-18.08Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M204.22,72.18l-5.77,19c-.38-.08-.76-.18-1.14-.27l5.8-19.09Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M224.42,75.7l-5.29,17.41c-.41,0-.81,0-1.23.07l5.41-17.81Z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.64,
    cy: 74.52,
    rx: 12.1,
    ry: 30.76,
    transform: "translate(96.24 263.91) rotate(-79.91)",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.27,
    cy: 74.63,
    rx: 8.55,
    ry: 24.34,
    transform: "translate(96.65 264.63) rotate(-79.91)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wallet--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.44,253.63l-102.91,6A30.32,30.32,0,0,0,209,262.19l-111.78,50a9.36,9.36,0,0,0-5.4,10.46L110.29,410a9.45,9.45,0,0,0,13.5,6.38l110.33-55.08L336,357.89a8.83,8.83,0,0,0,8.49-10.18l-13.63-83.64C330.15,259.75,326.87,253.5,322.44,253.63Z",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.44,253.63l-102.91,6A30.32,30.32,0,0,0,209,262.19l-111.78,50a9.36,9.36,0,0,0-5.4,10.46L110.29,410a9.45,9.45,0,0,0,13.5,6.38l110.33-55.08L336,357.89a8.83,8.83,0,0,0,8.49-10.18l-13.63-83.64C330.15,259.75,326.87,253.5,322.44,253.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.6,
    y: 202.73,
    width: 73.45,
    height: 142.99,
    transform: "translate(-149.5 165.66) rotate(-42.67)",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.78 301.9 158.77 351.68 61.87 246.55 97.31 213.88 115.88 196.76 118.97 200.12 212.78 301.9",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.32,
    y: 207.45,
    width: 64.81,
    height: 133.75,
    transform: "translate(-149.47 165.96) rotate(-42.67)",
    style: {
      fill: "none",
      stroke: "#1C485F",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137,
    cy: 273.55,
    rx: 13.46,
    ry: 16.88,
    transform: "translate(-149.13 165.27) rotate(-42.67)",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.2 309.01 139.01 315.64 97.31 213.88 115.88 196.76 118.97 200.12 158.2 309.01",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.05,
    y: 163.81,
    width: 73.45,
    height: 142.99,
    transform: "translate(-71.11 65.82) rotate(-19.93)",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.05,
    y: 163.81,
    width: 73.45,
    height: 142.99,
    transform: "translate(-71.11 65.82) rotate(-19.93)",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.69,
    y: 168.68,
    width: 64.81,
    height: 133.75,
    transform: "translate(-71.18 65.94) rotate(-19.93)",
    style: {
      fill: "none",
      stroke: "#1C485F",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.74,
    cy: 234.56,
    rx: 13.46,
    ry: 16.88,
    transform: "translate(-70.86 65.76) rotate(-19.93)",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.11,257.18l-101.5,5.72a29.06,29.06,0,0,0-10.41,2.55L101.06,315.17a9.35,9.35,0,0,0-5.3,10.44L114.23,413a9.35,9.35,0,0,0,13.34,6.41l108.7-54.77,100.48-3.18a8.75,8.75,0,0,0,8.36-10.15l-13.67-83.63C330.73,263.32,327.49,257.06,323.11,257.18Z",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.74,
    y1: 278.2,
    x2: 312.83,
    y2: 272.84,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.31,
    y1: 280.45,
    x2: 231.22,
    y2: 353.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.23,346.43l11.22,56.21S129.05,380.34,109.23,346.43Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,347.09c.39,1,99.66-41.6,99.66-41.6A52.24,52.24,0,0,1,183,352.89C153.12,369.64,110.7,347.09,110.7,347.09Z",
    style: {
      fill: "#fafafa",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.64,
    cy: 344.45,
    r: 4.3,
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.41,305.49s12.31,18.53,9.33,50.09",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 104.48,
    y1: 324.35,
    x2: 106.77,
    y2: 323.34,
    style: {
      fill: "none",
      stroke: "#fafafa",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.52,
    y1: 321.24,
    x2: 204.22,
    y2: 280.26,
    style: {
      fill: "none",
      stroke: "#fafafa",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "5.1975297927856445,5.1975297927856445"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.6,
    y1: 279.21,
    x2: 208.88,
    y2: 278.2,
    style: {
      fill: "none",
      stroke: "#fafafa",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 228.66,
    y1: 294.63,
    x2: 315.75,
    y2: 289.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.58,
    y1: 315.12,
    x2: 319.67,
    y2: 309.75,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.58,169.56s-2.19,23.33-10.86,25.34a26.16,26.16,0,0,1-16-1.6l-7.05-5.42-3.44,12s3.76,5.11,11.61,1.57c0,0,14,6.16,21.74,0s10.22-23.06,10.22-23.06Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.55,158.26s-6.05-10.31-3.3-29,18.42-21,24.47-19.65,11,7.16,15.12,18.22,5.64,13.94,12.51,12,25.15-8,30.24-2.61a12.64,12.64,0,0,1,3.43,11.4s25.43-6.18,23.23,16.5-38.9,43.85-73.81,21.44S307.55,158.26,307.55,158.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.27,213.15s-6.91,59.43-6.68,87.3S310.72,394,310.72,394h12.21s-1.61-52.52-1.38-70.49S325,275.81,325,275.81s3.91,26.72,8.52,36.16,30.18,42.85,47.92,53.22l8.29-7.61s-18.43-22.8-25.34-34.09S351.27,309,348.73,288s1.85-54.59-5.52-74.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,275.81l-5.31-37.67s-4.19,22.64,4.06,50.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.23 397.33 313.64 409 321.83 409.68 322.24 408.59 322.24 396.51 313.23 397.33",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.34 392.89 310.09 397.26 324.15 397.6 325.04 392.35 309.34 392.89",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.59 366 390.62 353.86 393.49 358.43 382.3 368.67 377.59 366",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.87 366 392.47 373.24 397.99 366.75 390.93 359.45 383.87 366",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.66,366.25l5.2,3.2a1.91,1.91,0,0,1,.43,2.89c-3.77,4.26-13.4,15.08-14.36,15.84-1.19,1-2.63-.68-3-2.18,0,0,2.73-3.62,3-5.94a42.48,42.48,0,0,0,0-5.38,1.77,1.77,0,0,1,.42-1.23l5.81-6.82A1.92,1.92,0,0,1,399.66,366.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.83,410l1.08,6a1.91,1.91,0,0,1-1.87,2.25c-5.69,0-20.17.06-21.38-.14-1.51-.25-1.24-2.41-.35-3.67,0,0,4.51-.38,6.4-1.75a43.19,43.19,0,0,0,4-3.56,1.79,1.79,0,0,1,1.2-.51l8.95-.21A1.93,1.93,0,0,1,323.83,410Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.52,180.19,357,171.43s-3.32-13.28-8.24-13.94-29.34-5.31-44.87,0c0,0-5.58,1.59-7.3,17.26l6.64,2.12s2.38,29.34,3.85,33.86h35.44S342.92,185.5,344.52,180.19Z",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.21,178.3s4.73,13.5,5.57,20.76c0,0-11.24-4.48-14.14-6.53l-2.2-7.9L329,181,326.79,187,333,194.7s16.93,15.84,25.51,12.22-3.39-34.14-3.39-34.14Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.46,119.19s-4.33,8.64-4,15.67,3.88,9.9,10.63,10.89c0,0,2.88,9-4.68,9.91-.58.07-.78,2.36-.74,2.73.2,1.46,1.65,2.26,3,2.6a20.3,20.3,0,0,0,4.33.48,10.09,10.09,0,0,0,8.07-3.59c.16-.19,1.68-2.13,1.68-2.13s-3.61-1.79-2.34-13.51a9.73,9.73,0,0,0,3.78-4.68,5.88,5.88,0,0,0,2.88-3.52c.54-2.34-1.53-5.58-5.31-2.34,0,0-7.12-3.6-9.82-16.21A12.63,12.63,0,0,1,315.46,119.19Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.49,132.94l.61-4.62-3.27,3.62A3.22,3.22,0,0,0,317.49,132.94Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.39,136.32s3.45.53,5.11-1.68",
    style: {
      fill: "none",
      stroke: "#222221",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.84,121.85a4.52,4.52,0,0,1,4.47,1.19",
    style: {
      fill: "none",
      stroke: "#222221",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.87,120.85s-2-.31-2.89.82",
    style: {
      fill: "none",
      stroke: "#222221",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,127.93c-.09.7-.54,1.21-1,1.15s-.77-.67-.68-1.37.54-1.21,1-1.15S324.32,127.23,324.23,127.93Z",
    style: {
      fill: "#222221"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.43,
    cy: 126.29,
    rx: 1.27,
    ry: 0.85,
    transform: "translate(149.54 422.81) rotate(-82.6)",
    style: {
      fill: "#222221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.56,126.56l-1.58-.69A1,1,0,0,0,323.56,126.56Z",
    style: {
      fill: "#222221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.72,125.08l-1.58-.69A1,1,0,0,0,315.72,125.08Z",
    style: {
      fill: "#222221"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.84 209.17 305.84 213.34 344.24 213.66 343.21 208.7 305.84 209.17",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.84 209.17 305.84 213.34 344.24 213.66 343.21 208.7 305.84 209.17",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Card--inject-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.31,188.93l-21.12,73.46a12.8,12.8,0,0,1-11,9.22,13.06,13.06,0,0,1-4.82-.44L229,259.56a12.83,12.83,0,0,1-8.78-15.85l21.13-73.48a12.82,12.82,0,0,1,15.84-8.76l40.4,11.6A12.82,12.82,0,0,1,306.31,188.93Z",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.31,188.93l-21.12,73.46a12.8,12.8,0,0,1-11,9.22,13.06,13.06,0,0,1-4.82-.44L229,259.56a12.83,12.83,0,0,1-8.78-15.85l21.13-73.48a12.82,12.82,0,0,1,15.84-8.76l40.4,11.6A12.82,12.82,0,0,1,306.31,188.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.8,189.8l-21.12,73.47a12.77,12.77,0,0,1-7.51,8.34,13.06,13.06,0,0,1-4.82-.44L229,259.56a12.83,12.83,0,0,1-8.78-15.85l21.13-73.48a12.74,12.74,0,0,1,7.51-8.32,12.65,12.65,0,0,1,4.82.44L294,174A12.82,12.82,0,0,1,302.8,189.8Z",
    style: {
      fill: "#1C485F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.8,189.8l-21.12,73.47a12.77,12.77,0,0,1-7.51,8.34,13.06,13.06,0,0,1-4.82-.44L229,259.56a12.83,12.83,0,0,1-8.78-15.85l21.13-73.48a12.74,12.74,0,0,1,7.51-8.32,12.65,12.65,0,0,1,4.82.44L294,174A12.82,12.82,0,0,1,302.8,189.8Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.85,
    y: 194.35,
    width: 4.49,
    height: 57.34,
    transform: "translate(69.34 -55.67) rotate(15.74)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.67 252.99 232.35 251.74 247.9 196.57 252.21 197.81 236.67 252.99",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.95 254.79 238.63 253.55 254.18 198.38 258.5 199.62 242.95 254.79",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.48,
    y: 205.16,
    width: 4.49,
    height: 57.34,
    transform: "translate(73.68 -65.48) rotate(15.74)",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.1,191.25,281,198.74l-2.56-.72a4.87,4.87,0,0,1-3.36-6l1.4-5,5.17,1.48A2.2,2.2,0,0,1,283.1,191.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.87,187.58l-5.17-1.48,1.55-5.48a4.86,4.86,0,0,1,6-3.36l2.66.75-2.32,8.07A2.17,2.17,0,0,1,281.87,187.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.77,190l5.2,1.49-1.38,4.89a4.84,4.84,0,0,1-6,3.36l-2.7-.76,2.15-7.48A2.19,2.19,0,0,1,286.77,190Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.81,185l-1.57,5.56-5.2-1.49a2.2,2.2,0,0,1-1.5-2.71l2.32-8.07,2.59.73A4.85,4.85,0,0,1,293.81,185Z",
    style: {
      fill: "#fafafa"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletRafiki);
export default __webpack_public_path__ + "static/media/Wallet-rafiki.a811af2ad4367d1dfeda42b0510cb1f5.svg";
export { ForwardRef as ReactComponent };